import * as am5 from "@amcharts/amcharts5"

import { dsColorNew } from "@palette"


// Corporate look for every amCharts chart in the app: font, text, grid, axes, tooltip and legend.
// Series colours are not touched — they come from each chart (and on some charts, from the user's own choices).
function corporateChartTheme(root) {
	const theme = am5.Theme.new(root)
	const color = hex => am5.color(hex)

	theme.rule("Label").setAll({
		fontFamily: "Roboto, sans-serif",
		fontSize: 13,
		fill: color(dsColorNew.textDark),
	})

	theme.rule("Grid").setAll({
		stroke: color(dsColorNew.grayBorder),
		strokeOpacity: 1,
	})

	theme.rule("AxisLabel").setAll({
		fontSize: 12,
		fill: color(dsColorNew.textMuted),
	})

	theme.rule("AxisRenderer").setAll({
		stroke: color(dsColorNew.grayBorder),
	})

	theme.rule("Tooltip").setAll({
		getFillFromSprite: false,
		autoTextColor: false,
	})
	theme.rule("PointedRectangle", ["tooltip", "background"]).setAll({
		fill: color(dsColorNew.white),
		fillOpacity: 1,
		stroke: color(dsColorNew.grayBorder),
		strokeOpacity: 1,
		shadowColor: color(dsColorNew.navy),
		shadowOpacity: 0.12,
		shadowBlur: 12,
		shadowOffsetY: 4,
	})
	theme.rule("Label", ["tooltip"]).setAll({
		fill: color(dsColorNew.textTitle),
	})
	// The cursor's label on the axes keeps a dark chip, so its text stays light.
	theme.rule("PointedRectangle", ["axis", "tooltip", "background"]).setAll({
		fill: color(dsColorNew.navy),
		fillOpacity: 1,
		strokeOpacity: 0,
		cornerRadius: 4,
	})
	theme.rule("Label", ["axis", "tooltip"]).setAll({
		fill: color(dsColorNew.white),
		fontSize: 12,
	})

	theme.rule("RoundedRectangle", ["legend", "marker", "rectangle"]).setAll({
		cornerRadiusTL: 3, cornerRadiusTR: 3, cornerRadiusBL: 3, cornerRadiusBR: 3,
	})
	theme.rule("Label", ["legend", "value", "label"]).setAll({
		fill: color(dsColorNew.textTitle),
		fontWeight: "600",
	})

	theme.rule("RoundedRectangle", ["series", "column"]).setAll({
		cornerRadiusTL: 3, cornerRadiusTR: 3,
	})

	return theme
}


// @ui-seeker builds each chart root itself and gives us no theme slot; it always calls setThemes() right
// after creating the root and before drawing anything, so appending the corporate theme there styles every
// chart in the app from one place.
let installed = false

export function installCorporateChartTheme() {
	if (installed) return
	installed = true

	const setThemes = am5.Root.prototype.setThemes
	am5.Root.prototype.setThemes = function (themes = []) {
		this.interfaceColors.setAll({
			grid: am5.color(dsColorNew.grayBorder),
			text: am5.color(dsColorNew.textDark),
			background: am5.color(dsColorNew.white),
		})
		return setThemes.call(this, [...themes, corporateChartTheme(this)])
	}
}
